<script>
import { Query } from "@sveltestack/svelte-query"
import API from "@local/utils/api"
import EmptyMessage from "@local/components/EmptyMessage.svelte"
import ListCommunications from "@local/components/ListCommunications.svelte"
import Breadcrumb from "@local/components/engine/elements/Breadcrumb.svelte"
import * as transformCommunications from "@local/utils/transformCommunications"

export let wfId

let showSMS = true
let showCall = true
let typesSelected = []
let breadcrumbItems = []

$: {
  typesSelected = []
  if (showSMS) {
    typesSelected.push("sms")
  }
  if (showCall) {
    typesSelected.push("call")
  }
}

async function fetchNotes({ wfId }) {
  const searchParams = { role: "admin" }
  const response = await API.get(`admin/workflow/${wfId}/communications`, {
    searchParams,
  })?.json()
  const rows = await response.events
  breadcrumbItems = [
    { label: "Home", url: "/", icon: "home" },
    {
      label: "Workflows",
      url: "/workflows?type=medical",
      icon: "medical_information",
    },
    {
      label: `${response?.name || ""}`,
      url: `/workflows/${wfId}`,
      icon: "person",
    },
    { label: "Communication Events" },
  ]
  return { rows }
}

$: queryOptions = {
  queryKey: ["communications", wfId],
  queryFn: () => fetchNotes({ wfId }),
  keepPreviousData: true,
  refetchOnWindowFocus: false,
}
</script>

<Query options="{queryOptions}">
  <div slot="query" let:queryResult>
    {#if queryResult.isLoading}
      <div></div>
    {:else if queryResult.error}
      <EmptyMessage icon="error">{queryResult.error}</EmptyMessage>
    {:else}
      <div class="p-5">
        <Breadcrumb items="{breadcrumbItems}" />
        <div class="flex flex-1 items-center mb-8">
          <h2 class="h2">Communication Events</h2>
        </div>

        <div class="flex flex-1 items-center mb-8 text">
          <p>Filter by type:</p>
          <div class="ml-8 font-semibold select-none">
            <input type="checkbox" id="call" bind:checked="{showCall}" />
            <label class="ml-2" for="call">Calls</label>
          </div>

          <div class="ml-8 font-semibold select-none">
            <input type="checkbox" id="sms" bind:checked="{showSMS}" />
            <label class="ml-2" for="sms">SMSs</label>
          </div>
        </div>
        {#if queryResult.data.rows.length > 0}
          <div class="md:w-1/2">
            <ListCommunications
              content="{transformCommunications.toAllCommunications(
                queryResult.data.rows
              )}"
              reduced="{false}"
              typesToShow="{typesSelected}"
              emptyListMessage="no events found"
            />
          </div>
        {/if}
      </div>
    {/if}
  </div>
</Query>
